<div class="form-builder-menu-container">
  <h6>Element list</h6>
  <rappider-divider></rappider-divider>
  <h3 class="form-builder-menu-title">Add an Element</h3>
  <div class="menu-wrapper">
    <rappider-menu *ngIf="menuConfig"
                   [config]="menuConfig"
                   (menuItemClick)="onMenuItemClick($event)">
    </rappider-menu>
  </div>
</div>
